// Données de la Centrale d'Achat & Marketplace Agricole Agri Vision Gabon
// Connectées au référentiel agronomique et à la traçabilité AVG Farm
import imgManioc from "../../img/products/manioc.jpg";
import imgPlantain from "../../img/products/plantain.jpg";
import imgAnanas from "../../img/products/ananas.jpg";
import imgTomate from "../../img/products/tomate.jpg";
import imgPiment from "../../img/products/piment.jpg";
import imgAubergine from "../../img/products/aubergine.jpg";
import imgCacao from "../../img/products/cacao.jpg";
import imgCafe from "../../img/products/cafe.jpg";
import imgPassion from "../../img/products/passion.jpg";

export const PRODUCT_IMAGES = {
  "Manioc": imgManioc,
  "Ananas (Victoria)": imgAnanas,
  "Maraîchage (Piment)": imgPiment,
  "Banane plantain": imgPlantain,
  "Cacao": imgCacao,
  "Maraîchage (Tomate)": imgTomate,
  "Café": imgCafe,
  "Maraîchage (Aubergine)": imgAubergine,
  "Fruit de la passion": imgPassion,
};

export const PROVINCE_INFOS = {
  "Estuaire": {
    code: "GA1",
    capital: "Libreville",
    speciality: "Approvisionnement exclusif Grand Libreville (Akanda, Owendo, Libreville)",
    description: "Centrale d'achat en phase pilote dédiée à l'approvisionnement du Grand Libreville. Maraîchage d'exception, tubercules doux et fruits frais bord champ livrés sous 24h.",
    totalProducers: 145,
    hectaresTraced: 420,
    deliveryDelay: "24h (Grand Libreville)"
  },
  "Haut-Ogooué": {
    code: "GA2",
    capital: "Franceville / Moanda",
    speciality: "Plateaux maraîchers, manioc & maïs grain",
    description: "Bassins de production de Franceville, Leconi et Moanda. Approvisionnement direct des centres miniers et urbains.",
    totalProducers: 98,
    hectaresTraced: 310,
    deliveryDelay: "24-48h"
  },
  "Moyen-Ogooué": {
    code: "GA3",
    capital: "Lambaréné",
    speciality: "Carrefour fluvial, manioc blanc & banane plantain",
    description: "Zone charnière de distribution fluviale et routière reliant le Nord et le Sud du Gabon.",
    totalProducers: 112,
    hectaresTraced: 380,
    deliveryDelay: "24-48h"
  },
  "Ngounié": {
    code: "GA4",
    capital: "Mouila / Ndendé",
    speciality: "Grandes plaines céréalières, riz & plantain",
    description: "Terres fertiles de Mouila et Ndendé avec projets de riziculture et cultures vivrières d'envergure.",
    totalProducers: 130,
    hectaresTraced: 520,
    deliveryDelay: "48h"
  },
  "Nyanga": {
    code: "GA5",
    capital: "Tchibanga / Mayumba",
    speciality: "Savanes vivrières, manioc, taro & élevage",
    description: "Bassin agricole méridional de Tchibanga avec ouverture maritime à Mayumba.",
    totalProducers: 84,
    hectaresTraced: 290,
    deliveryDelay: "48-72h"
  },
  "Ogooué-Ivindo": {
    code: "GA6",
    capital: "Makokou / Booué",
    speciality: "Forêts équatoriales, cacao biologique & café robusta",
    description: "Cultures pérennes sous couvert forestier, fèves de cacao certifiées et tubercules de qualité supérieure.",
    totalProducers: 76,
    hectaresTraced: 260,
    deliveryDelay: "48-72h"
  },
  "Ogooué-Lolo": {
    code: "GA7",
    capital: "Koula-Moutou / Lastoursville",
    speciality: "Arachides, manioc traditionnel & piments",
    description: "Centre-Est agricole réputé pour sa production d'arachides et de tubercules fermes.",
    totalProducers: 88,
    hectaresTraced: 275,
    deliveryDelay: "48-72h"
  },
  "Ogooué-Maritime": {
    code: "GA8",
    capital: "Port-Gentil / Omboué",
    speciality: "Maraîchage sous abri & pastèque insulaire",
    description: "Approvisionnement frais de la capitale économique Port-Gentil et de la zone insulaire du Fernan Vaz.",
    totalProducers: 62,
    hectaresTraced: 195,
    deliveryDelay: "24-48h (Port-Gentil)"
  },
  "Wouleu-Ntem": {
    code: "GA9",
    capital: "Oyem / Bitam",
    speciality: "Grenier agricole national, plantain géant & cacao d'export",
    description: "Frontière nord stratégique (Cameroun / Guinée Équatoriale). Premier producteur de banane plantain et de cacao.",
    totalProducers: 185,
    hectaresTraced: 680,
    deliveryDelay: "48h vers Libreville"
  }
};

export const MARKETPLACE_LOTS = [
  // --- ESTUAIRE (Approvisionnement Grand Libreville : Akanda, Owendo, Libreville) ---
  {
    id: "AVG-LOT-EST-001",
    product: "Manioc",
    variety: "Tubercules Frais de Manioc Doux",
    category: "Tubercules & Féculents",
    province: "Estuaire",
    deliveryZone: "Grand Libreville",
    cooperative: "Filière Certifiée AVG Farm",
    status: "in_stock", // in_stock | preorder
    availableTonnes: 14.5,
    pricePerKg: 380,
    pricePerTonne: 350000,
    minOrderKg: 50,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Livraison Grand Libreville sous 24h",
    certifications: ["Traçabilité AVG Farm", "Zéro Résidu Chimique"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Tubercules frais fraîchement récoltés bord champ, chair blanche et ferme, idéal pour bâtons de manioc ou consommation bouillie. Livraison garantie dans le Grand Libreville (Akanda, Owendo, Libreville).",
    imageUrl: PRODUCT_IMAGES["Manioc"] || imgManioc
  },
  {
    id: "AVG-LOT-EST-002",
    product: "Ananas (Victoria)",
    variety: "Victoria Extra Sweet",
    category: "Fruits",
    province: "Estuaire",
    deliveryZone: "Grand Libreville",
    cooperative: "Filière Certifiée AVG Farm",
    status: "preorder",
    availableTonnes: 18.0,
    pricePerKg: 650,
    pricePerTonne: 600000,
    minOrderKg: 100,
    harvestDate: "2026-11-15",
    daysToHarvest: 40,
    deliveryWindow: "Disponible mi-novembre 2026 • Grand Libreville",
    certifications: ["GlobalG.A.P. Ready", "Traçabilité AVG Farm", "Calibre A Export"],
    targetBuyers: ["B2B", "Export", "Particuliers"],
    description: "Ananas Victoria doré au goût sucré intense et arôme puissant. Cycle de 15 mois piloté sous protocole AVG Farm. Livraison garantie dans le Grand Libreville (Akanda, Owendo, Libreville).",
    imageUrl: PRODUCT_IMAGES["Ananas (Victoria)"] || imgManioc
  },
  {
    id: "AVG-LOT-EST-003",
    product: "Maraîchage (Piment)",
    variety: "Piment Bec d'Oiseau Frais",
    category: "Maraîchage",
    province: "Estuaire",
    deliveryZone: "Grand Libreville",
    cooperative: "Filière Certifiée AVG Farm",
    status: "in_stock",
    availableTonnes: 2.8,
    pricePerKg: 1400,
    pricePerTonne: 1300000,
    minOrderKg: 10,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Livraison Grand Libreville sous 24h",
    certifications: ["Traçabilité AVG Farm", "Récolte du jour"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Piment rouge et vert très piquant, fraîchement cueilli pour restaurants, hôtels et détaillants. Livraison quotidienne garantie dans le Grand Libreville (Akanda, Owendo, Libreville).",
    imageUrl: PRODUCT_IMAGES["Maraîchage (Piment)"] || imgManioc
  },
  {
    id: "AVG-LOT-EST-004",
    product: "Banane plantain",
    variety: "Banane Plantain Corne Géant",
    category: "Tubercules & Féculents",
    province: "Estuaire",
    deliveryZone: "Grand Libreville",
    cooperative: "Filière Certifiée AVG Farm",
    status: "in_stock",
    availableTonnes: 12.0,
    pricePerKg: 460,
    pricePerTonne: 430000,
    minOrderKg: 80,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Livraison Grand Libreville sous 24h",
    certifications: ["Traçabilité AVG Farm", "Régimes Sélectionnés"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Régimes vigoureux de 14 à 20 kg, banane plantain fraîche bord champ, chair jaune ferme pour braiser, frire ou piler. Livraison sous 24h dans le Grand Libreville (Akanda, Owendo, Libreville).",
    imageUrl: PRODUCT_IMAGES["Banane plantain"] || imgPlantain
  },
  {
    id: "AVG-LOT-EST-005",
    product: "Maraîchage (Tomate)",
    variety: "Tomate Roma Plein Champ",
    category: "Maraîchage",
    province: "Estuaire",
    deliveryZone: "Grand Libreville",
    cooperative: "Filière Certifiée AVG Farm",
    status: "in_stock",
    availableTonnes: 5.5,
    pricePerKg: 720,
    pricePerTonne: 680000,
    minOrderKg: 20,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Livraison Grand Libreville sous 24h",
    certifications: ["Traçabilité AVG Farm", "Cueillette du jour"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Tomates charnues et fermes de plein champ. Idéales pour la cuisine quotidienne et les traiteurs. Livraison sous 24h dans le Grand Libreville (Akanda, Owendo, Libreville).",
    imageUrl: PRODUCT_IMAGES["Maraîchage (Tomate)"] || imgTomate
  },
  {
    id: "AVG-LOT-EST-006",
    product: "Maraîchage (Aubergine)",
    variety: "Aubergines Violettes du Terroir",
    category: "Maraîchage",
    province: "Estuaire",
    deliveryZone: "Grand Libreville",
    cooperative: "Filière Certifiée AVG Farm",
    status: "in_stock",
    availableTonnes: 3.2,
    pricePerKg: 580,
    pricePerTonne: 540000,
    minOrderKg: 15,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Livraison Grand Libreville sous 24h",
    certifications: ["Traçabilité AVG Farm", "Zéro Résidu Chimique"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Aubergines brillantes à chair tendre sans amertume, sélectionnées avec soin bord champ. Livraison sous 24h dans le Grand Libreville (Akanda, Owendo, Libreville).",
    imageUrl: PRODUCT_IMAGES["Maraîchage (Aubergine)"] || imgAubergine
  },
  {
    id: "AVG-LOT-EST-007",
    product: "Fruit de la passion",
    variety: "Maracuja Pourpre Doux",
    category: "Fruits",
    province: "Estuaire",
    deliveryZone: "Grand Libreville",
    cooperative: "Filière Certifiée AVG Farm",
    status: "preorder",
    availableTonnes: 6.0,
    pricePerKg: 950,
    pricePerTonne: 890000,
    minOrderKg: 25,
    harvestDate: "2026-11-10",
    daysToHarvest: 34,
    deliveryWindow: "Disponible mi-novembre 2026 • Grand Libreville",
    certifications: ["GlobalG.A.P. Ready", "Traçabilité AVG Farm", "Qualité Jus & Table"],
    targetBuyers: ["B2B", "Hôtels & Restaurants", "Particuliers"],
    description: "Fruits de la passion très parfumés au goût acidulé et sucré, pulpe riche pour jus frais, cocktails et pâtisserie. Livraison garantie dans le Grand Libreville (Akanda, Owendo, Libreville).",
    imageUrl: PRODUCT_IMAGES["Fruit de la passion"] || imgPassion
  },
  {
    id: "AVG-LOT-EST-008",
    product: "Patate douce",
    variety: "Patate Douce Orange à Chair Fondante",
    category: "Tubercules & Féculents",
    province: "Estuaire",
    deliveryZone: "Grand Libreville",
    cooperative: "Filière Certifiée AVG Farm",
    status: "in_stock",
    availableTonnes: 8.5,
    pricePerKg: 390,
    pricePerTonne: 360000,
    minOrderKg: 40,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Livraison Grand Libreville sous 24h",
    certifications: ["Traçabilité AVG Farm", "Riche en Bêta-Carotène"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Patate douce orange à chair fondante et très nutritive. Récoltée à point bord champ sous contrôle de qualité. Livraison sous 24h dans le Grand Libreville (Akanda, Owendo, Libreville).",
    imageUrl: PRODUCT_IMAGES["Manioc"] || imgManioc
  },

  // --- WOULEU-NTEM ---
  {
    id: "AVG-LOT-WNT-001",
    product: "Banane plantain",
    variety: "Plantain Corne Géant d'Oyem",
    category: "Tubercules & Féculents",
    province: "Wouleu-Ntem",
    cooperative: "Union des Planteurs du Grand Nord (Oyem)",
    status: "in_stock",
    availableTonnes: 28.0,
    pricePerKg: 450,
    pricePerTonne: 420000,
    minOrderKg: 100,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Expédition groupée vers Libreville sous 48h",
    certifications: ["Traçabilité AVG Farm", "Sélection Gros Régimes"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Régimes vigoureux de 12 à 18 kg, chair ferme et savoureuse, récoltés dans le grand bassin du Woleu-Ntem.",
    imageUrl: PRODUCT_IMAGES["Banane plantain"] || imgManioc
  },
  {
    id: "AVG-LOT-WNT-002",
    product: "Cacao",
    variety: "Fèves Marchandes Fermentées Grade 1",
    category: "Cultures de Rente",
    province: "Wouleu-Ntem",
    cooperative: "Coopérative Cacaoyère de Bitam",
    status: "preorder",
    availableTonnes: 35.0,
    pricePerKg: 2850,
    pricePerTonne: 2750000,
    minOrderKg: 500,
    harvestDate: "2026-11-28",
    daysToHarvest: 53,
    deliveryWindow: "Campagne principale fin novembre 2026",
    certifications: ["Fèves certifiées ONPV", "Traçabilité AVG Farm", "Fermentation 6 jours"],
    targetBuyers: ["B2B", "Export"],
    description: "Cacao grand cru de Bitam issu de parcelles ombragées. Taux d'humidité contrôlé inférieur à 7.5%.",
    imageUrl: PRODUCT_IMAGES["Cacao"] || imgManioc
  },
  {
    id: "AVG-LOT-WNT-003",
    product: "Maraîchage (Tomate)",
    variety: "Tomate Roma Plein Champ",
    category: "Maraîchage",
    province: "Wouleu-Ntem",
    cooperative: "Fermes Maraîchères de Mitzic",
    status: "in_stock",
    availableTonnes: 7.2,
    pricePerKg: 680,
    pricePerTonne: 640000,
    minOrderKg: 30,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Cagettes ventilées 20kg",
    certifications: ["Traçabilité AVG Farm", "Cueillette matinale"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Tomates fermes à chair dense, excellente tenue au transport et idéale pour la conservation.",
    imageUrl: PRODUCT_IMAGES["Maraîchage (Tomate)"] || imgManioc
  },

  // --- MOYEN-OGOOUÉ ---
  {
    id: "AVG-LOT-MOG-001",
    product: "Manioc",
    variety: "Manioc Doux Blanc de Lambaréné",
    category: "Tubercules & Féculents",
    province: "Moyen-Ogooué",
    cooperative: "Union Agricole Fluviale (Lambaréné)",
    status: "in_stock",
    availableTonnes: 19.0,
    pricePerKg: 350,
    pricePerTonne: 320000,
    minOrderKg: 100,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Transport fluvial / routier rapide",
    certifications: ["Traçabilité AVG Farm", "Standard Bâton"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Production des rives de l'Ogooué à fort taux de fécule, calibrée pour les ateliers de transformation.",
    imageUrl: PRODUCT_IMAGES["Manioc"] || imgManioc
  },
  {
    id: "AVG-LOT-MOG-002",
    product: "Banane plantain",
    variety: "Plantain Doux de Ndjolé",
    category: "Tubercules & Féculents",
    province: "Moyen-Ogooué",
    cooperative: "Planteurs Réunis de Ndjolé",
    status: "preorder",
    availableTonnes: 11.5,
    pricePerKg: 460,
    pricePerTonne: 430000,
    minOrderKg: 80,
    harvestDate: "2026-10-25",
    daysToHarvest: 19,
    deliveryWindow: "Récolte prévue dans 19 jours",
    certifications: ["Traçabilité AVG Farm"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Plantains précoces arrivant à maturité optimale sur parcelles alluviales très riches.",
    imageUrl: PRODUCT_IMAGES["Banane plantain"] || imgManioc
  },

  // --- HAUT-OGOOUÉ ---
  {
    id: "AVG-LOT-HOG-001",
    product: "Maraîchage (Tomate)",
    variety: "Tomate Grappe de Franceville",
    category: "Maraîchage",
    province: "Haut-Ogooué",
    cooperative: "Coopérative Maraîchère du Plateau (Franceville)",
    status: "in_stock",
    availableTonnes: 8.5,
    pricePerKg: 620,
    pricePerTonne: 590000,
    minOrderKg: 25,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Livraison locale & Libreville",
    certifications: ["Traçabilité AVG Farm", "Plein champ"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Tomates savoureuses cultivées sur sols ferrallitiques aérés du Haut-Ogooué.",
    imageUrl: PRODUCT_IMAGES["Maraîchage (Tomate)"] || imgManioc
  },
  {
    id: "AVG-LOT-HOG-002",
    product: "Manioc",
    variety: "Manioc Jaune Bioenrichi",
    category: "Tubercules & Féculents",
    province: "Haut-Ogooué",
    cooperative: "Groupement Moanda Agricole",
    status: "preorder",
    availableTonnes: 16.0,
    pricePerKg: 410,
    pricePerTonne: 380000,
    minOrderKg: 100,
    harvestDate: "2026-11-10",
    daysToHarvest: 35,
    deliveryWindow: "Disponible début novembre 2026",
    certifications: ["Traçabilité AVG Farm", "Variété enrichie en vitamine A"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Variété sélectionnée à chair jaune riche en caroténoïdes pour une nutrition optimale.",
    imageUrl: PRODUCT_IMAGES["Manioc"] || imgManioc
  },

  // --- NGOUNIÉ ---
  {
    id: "AVG-LOT-NGO-001",
    product: "Banane plantain",
    variety: "Banane Plantain de Mouila",
    category: "Tubercules & Féculents",
    province: "Ngounié",
    cooperative: "Bassin Vivrier de Mouila",
    status: "in_stock",
    availableTonnes: 17.5,
    pricePerKg: 430,
    pricePerTonne: 400000,
    minOrderKg: 100,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Disponible immédiatement",
    certifications: ["Traçabilité AVG Farm"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Excellente qualité de plantain, gros régimes de première coupe, approvisionnement régulier garanti.",
    imageUrl: PRODUCT_IMAGES["Banane plantain"] || imgManioc
  },
  {
    id: "AVG-LOT-NGO-002",
    product: "Manioc",
    variety: "Manioc de Ndendé",
    category: "Tubercules & Féculents",
    province: "Ngounié",
    cooperative: "Agri-Ndendé Terres Fertiles",
    status: "preorder",
    availableTonnes: 22.0,
    pricePerKg: 360,
    pricePerTonne: 330000,
    minOrderKg: 200,
    harvestDate: "2026-11-20",
    daysToHarvest: 45,
    deliveryWindow: "Récolte planifiée fin novembre",
    certifications: ["Traçabilité AVG Farm", "Contrat d'approvisionnement"],
    targetBuyers: ["B2B"],
    description: "Lot volumineux destiné aux transformateurs agroalimentaires et distributeurs nationaux.",
    imageUrl: PRODUCT_IMAGES["Manioc"] || imgManioc
  },

  // --- OGOOUÉ-IVINDO ---
  {
    id: "AVG-LOT-OIV-001",
    product: "Cacao",
    variety: "Fèves Forêt Vierge de Makokou",
    category: "Cultures de Rente",
    province: "Ogooué-Ivindo",
    cooperative: "Union Cacaoyère Makokou-Booué",
    status: "preorder",
    availableTonnes: 16.5,
    pricePerKg: 2900,
    pricePerTonne: 2800000,
    minOrderKg: 300,
    harvestDate: "2026-12-05",
    daysToHarvest: 60,
    deliveryWindow: "Disponible début décembre 2026",
    certifications: ["GlobalG.A.P. Ready", "Traçabilité AVG Farm", "Zéro Déforestation"],
    targetBuyers: ["B2B", "Export"],
    description: "Fèves nobles sous certification zéro déforestation, profil aromatique boisé et fruité.",
    imageUrl: PRODUCT_IMAGES["Cacao"] || imgManioc
  },
  {
    id: "AVG-LOT-OIV-002",
    product: "Café",
    variety: "Robusta Sauvage de l'Ivindo",
    category: "Cultures de Rente",
    province: "Ogooué-Ivindo",
    cooperative: "Caféiculteurs de l'Ivindo",
    status: "in_stock",
    availableTonnes: 5.5,
    pricePerKg: 1850,
    pricePerTonne: 1750000,
    minOrderKg: 50,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Sacs de jute 60kg",
    certifications: ["Traçabilité AVG Farm", "Séché au soleil"],
    targetBuyers: ["B2B", "Torréfacteurs", "Particuliers"],
    description: "Cerises de café robusta cueillies à maturité rouge, décortiquées et séchées naturellement.",
    imageUrl: PRODUCT_IMAGES["Café"] || imgManioc
  },

  // --- OGOOUÉ-LOLO ---
  {
    id: "AVG-LOT-OLO-001",
    product: "Manioc",
    variety: "Manioc Tubercules Fermes de Koula-Moutou",
    category: "Tubercules & Féculents",
    province: "Ogooué-Lolo",
    cooperative: "Coopérative Vivrière de la Lolo",
    status: "in_stock",
    availableTonnes: 11.0,
    pricePerKg: 370,
    pricePerTonne: 340000,
    minOrderKg: 60,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Livraison sous 48h",
    certifications: ["Traçabilité AVG Farm"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Culture de coteaux sableux garantissant une faible teneur en eau et une conservation prolongée.",
    imageUrl: PRODUCT_IMAGES["Manioc"] || imgManioc
  },
  {
    id: "AVG-LOT-OLO-002",
    product: "Maraîchage (Aubergine)",
    variety: "Aubergine Violette & Locale",
    category: "Maraîchage",
    province: "Ogooué-Lolo",
    cooperative: "Maraîchers de Lastoursville",
    status: "preorder",
    availableTonnes: 4.2,
    pricePerKg: 850,
    pricePerTonne: 800000,
    minOrderKg: 20,
    harvestDate: "2026-10-30",
    daysToHarvest: 24,
    deliveryWindow: "Récolte prévue fin octobre 2026",
    certifications: ["Traçabilité AVG Farm", "Récolte échelonnée"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Aubergines fermes et luisantes, adaptées aux plats traditionnels et à la restauration.",
    imageUrl: PRODUCT_IMAGES["Maraîchage (Aubergine)"] || imgManioc
  },

  // --- NYANGA ---
  {
    id: "AVG-LOT-NYA-001",
    product: "Banane plantain",
    variety: "Plantain Côtier de Mayumba",
    category: "Tubercules & Féculents",
    province: "Nyanga",
    cooperative: "Union Littorale de la Nyanga (Mayumba)",
    status: "in_stock",
    availableTonnes: 9.8,
    pricePerKg: 460,
    pricePerTonne: 430000,
    minOrderKg: 80,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Expédition Sud-Gabon & Libreville",
    certifications: ["Traçabilité AVG Farm"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Saveur iodée unique, plantains denses et résistants, issus des riches vallées de Mayumba.",
    imageUrl: PRODUCT_IMAGES["Banane plantain"] || imgManioc
  },
  {
    id: "AVG-LOT-NYA-002",
    product: "Manioc",
    variety: "Tubercules Blancs de Tchibanga",
    category: "Tubercules & Féculents",
    province: "Nyanga",
    cooperative: "Groupement Rural Tchibanga-Centre",
    status: "preorder",
    availableTonnes: 15.0,
    pricePerKg: 360,
    pricePerTonne: 330000,
    minOrderKg: 100,
    harvestDate: "2026-11-18",
    daysToHarvest: 43,
    deliveryWindow: "Disponible mi-novembre 2026",
    certifications: ["Traçabilité AVG Farm"],
    targetBuyers: ["B2B", "Particuliers"],
    description: "Récolte programmée de 15 tonnes de manioc de savane, calibré pour approvisionner les marchés urbains.",
    imageUrl: PRODUCT_IMAGES["Manioc"] || imgManioc
  },

  // --- OGOOUÉ-MARITIME ---
  {
    id: "AVG-LOT-OMA-001",
    product: "Maraîchage (Tomate)",
    variety: "Tomate Sous Serre de Port-Gentil",
    category: "Maraîchage",
    province: "Ogooué-Maritime",
    cooperative: "Ceinture Verte Maritime (Port-Gentil)",
    status: "in_stock",
    availableTonnes: 3.5,
    pricePerKg: 950,
    pricePerTonne: 900000,
    minOrderKg: 20,
    harvestDate: null,
    daysToHarvest: 0,
    deliveryWindow: "Livraison expresse Port-Gentil & Libreville",
    certifications: ["Traçabilité AVG Farm", "Sous abri protégé"],
    targetBuyers: ["B2B", "Hôtels & Restaurants", "Particuliers"],
    description: "Tomates de calibre premium cultivées sous abri maraîcher, peau lisse et goût sucré.",
    imageUrl: PRODUCT_IMAGES["Maraîchage (Tomate)"] || imgManioc
  },
  {
    id: "AVG-LOT-OMA-002",
    product: "Fruit de la passion",
    variety: "Maracuja Jaune Équatorial",
    category: "Fruits",
    province: "Ogooué-Maritime",
    cooperative: "Fermes Lagunaires d'Omboué",
    status: "preorder",
    availableTonnes: 6.0,
    pricePerKg: 1200,
    pricePerTonne: 1100000,
    minOrderKg: 30,
    harvestDate: "2026-11-05",
    daysToHarvest: 30,
    deliveryWindow: "Récolte prévue début novembre 2026",
    certifications: ["Traçabilité AVG Farm", "Fruits frais pour jus & desserts"],
    targetBuyers: ["B2B", "Agro-industrie", "Particuliers"],
    description: "Fruits de la passion très parfumés, forte teneur en jus naturel pour limonaderies et restaurants.",
    imageUrl: PRODUCT_IMAGES["Fruit de la passion"] || imgManioc
  }
];

// Statistiques globales de la centrale d'achat
export const getMarketplaceMetrics = () => {
  const totalTonnes = MARKETPLACE_LOTS.reduce((acc, lot) => acc + lot.availableTonnes, 0);
  const inStockTonnes = MARKETPLACE_LOTS
    .filter(lot => lot.status === "in_stock")
    .reduce((acc, lot) => acc + lot.availableTonnes, 0);
  const preorderTonnes = MARKETPLACE_LOTS
    .filter(lot => lot.status === "preorder")
    .reduce((acc, lot) => acc + lot.availableTonnes, 0);

  return {
    totalTonnes: Math.round(totalTonnes * 10) / 10,
    inStockTonnes: Math.round(inStockTonnes * 10) / 10,
    preorderTonnes: Math.round(preorderTonnes * 10) / 10,
    totalProducers: 980,
    totalLots: MARKETPLACE_LOTS.length,
    coveredProvinces: 9
  };
};
